import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowLeft, QrCode } from 'lucide-react';

const EventEditorHeader = ({ event, onShowQR }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 sm:mb-6 gap-3 sm:gap-4">
      <div className="flex items-center gap-3 sm:gap-4">
        <Button
          data-testid="back-button"
          onClick={() => navigate('/dashboard')}
          variant="outline"
          size="icon"
          className="border-violet-300 text-violet-600 hover:bg-violet-50 hover:border-violet-400 flex-shrink-0 min-w-[40px] min-h-[40px]"
        >
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div className="min-w-0">
          <h1 className="text-lg sm:text-2xl font-bold text-gray-900 truncate">
            {event?.name || 'Événement'}
          </h1>
          <p className="text-gray-500 text-xs sm:text-sm">Gestion de l&apos;événement</p>
        </div>
      </div>
      <Button
        data-testid="qr-code-button"
        onClick={onShowQR}
        variant="outline"
        size="sm"
        className="border-violet-300 text-violet-600 hover:bg-violet-50 hover:border-violet-400 self-end sm:self-auto text-xs sm:text-sm"
      >
        <QrCode className="w-4 h-4 sm:mr-2" />
        <span className="hidden sm:inline">QR Code Invités</span>
        <span className="sm:hidden">QR Code</span>
      </Button>
    </div>
  );
};

export default EventEditorHeader;
